<template>
  <div class="landing hero is-primary is-fullheight">
    <TheNavbar />
    <div class="hero-body">
      <div class="container has-text-centered">
        <h1 class="title">
          Machete
        </h1>
        <h2 class="subtitle">
          The Financial Solution
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import TheNavbar from '@/components/Landing/TheNavbar.vue';

export default {
  name: 'Landing',
  components: {
    TheNavbar,
  },
};
</script>

<style scoped>
.hero {
  background: linear-gradient(#39455B, #262F40);
}
</style>
